// =====================================================
// FormDisplay.jsx – Show generated images with slider
// =====================================================

import React, { useEffect, useState, useRef } from "react";
import styles from "../assets/styles/FormDisplay.module.css";
import axios from "axios";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function FormDisplay() {
  const username = localStorage.getItem("username");
  const productName = localStorage.getItem("productName");
  const [images, setImages] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const sliderRef = useRef(null);

  /* ---------- Fetch list of image files ---------- */
  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(
          `http://localhost:5000/api/images/${username}/${productName}`
        );
        const files = res.data.files || [];
        setImages(files);
        setSelectedIndex(0);
      } catch (e) {
        console.error("Image list load error:", e);
      }
    };
    load();
  }, [username, productName]);

  /* ---------- Helper: build image URL ---------- */
  const imgUrl = (file) =>
    `http://localhost:5000/api/image/${username}/${productName}/${file}`;

  /* ---------- Slider navigation ---------- */
  const scrollByThumbnails = (dir = "right") => {
    if (!sliderRef.current) return;
    const scrollAmount = sliderRef.current.firstChild?.clientWidth || 120; // thumbnail width
    sliderRef.current.scrollBy({
      left: dir === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const selectedImage = images[selectedIndex];

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Generated Forms for: {productName}</h2>

      {/* ---------- Large preview ---------- */}
      <div className={styles.previewArea}>
        {selectedImage ? (
          <img
            src={imgUrl(selectedImage)}
            alt="selected"
            className={styles.mainImage}
          />
        ) : (
          <p>No images found.</p>
        )}
      </div>

      {/* ---------- Thumbnail ribbon ---------- */}
      {images.length > 0 && (
        <div className={styles.sliderWrapper}>
          {/* left arrow */}
          <button
            className={styles.navBtn}
            onClick={() => scrollByThumbnails("left")}
            aria-label="Scroll left"
          >
            <FaChevronLeft />
          </button>

          {/* scrollable thumbnails */}
          <div className={styles.slider} ref={sliderRef}>
            {images.map((file, idx) => (
              <img
                key={file}
                src={imgUrl(file)}
                alt={file}
                className={`${styles.thumbnail} ${
                  idx === selectedIndex ? styles.active : ""
                }`}
                onClick={() => setSelectedIndex(idx)}
              />
            ))}
          </div>

          {/* right arrow */}
          <button
            className={styles.navBtn}
            onClick={() => scrollByThumbnails("right")}
            aria-label="Scroll right"
          >
            <FaChevronRight />
          </button>
        </div>
      )}
    </div>
  );
}

export default FormDisplay;
